import React, { useState } from 'react';
// import {operator} from '../components/affiliate';

function Todo({todo, index}) {
    return (
           
            <li class="card">
              <img src={todo.img} className="card-img-top" alt="..." />
              <div class="card-body">
                  <p className="card__price">{todo.ordpris}</p>
                <h3 class="card__title">{todo.prodnamn}</h3>
                <p className="card__brodtext">{todo.text}</p>
                <a href={todo.recUrl} className="card__link">Läs recension</a>
                <a href={todo.buttonUrl} class="btn btn-warning" target="_blank" rel="noopener noreferrer">Köp nu</a>
              </div>
            </li>  
    )
}

function App() {
    // const namn = {operator};
    // console.log(namn.operator[0]);
    const [todos] = useState([
        {
            img: '/genius_2.webp',
            pris: '279:-',
            ordpris: '2499:-',
            prodnamn: 'GENIUS X',
            text: 'Rose Gold Eltandborste',
            recUrl: '/beconfident',
            buttonUrl: 'https://ion.lyko.com/t/t?a=1117786221&as=1480987224&t=2&tk=1&url=https://lyko.com/sv/oral-b/oral-b-genius-x-20200s-rose-gold-eltandborste'
        },
        {
            img: '/genius_1.webp',
            pris: '599:-',
            ordpris: '3999:-',
            prodnamn: 'Genius X',
            text: 'RoseG SUT/Black CA Black Duopack',
            recUrl: '/dentaworks',
            buttonUrl: 'https://ion.lyko.com/t/t?a=1117786221&as=1480987224&t=2&tk=1&url=https://lyko.com/sv/oral-b/oral-b-genius-x-20900-roseg-sut-black-ca-black'
        },
        {
            img: '/genius_3.webp',
            pris: '599:-',
            ordpris: '2499:-',
            prodnamn: 'Genius X',
            text: 'Blush Pink SUT',
            recUrl: '/dentway',
            buttonUrl: 'https://ion.lyko.com/t/t?a=1117786221&as=1480987224&t=2&tk=1&url=https://lyko.com/sv/oral-b/oral-b-genius-x-20100s-blush-pink-sut'
        }
    ])

    return (
            <ul class="card-show">
                {todos.map((todo, index) => (
                <Todo key={index} index={index} todo={todo} /> 
                ))}
            </ul>
    )

}

export default App;

